export default __webpack_public_path__ + "static/media/megane-rs-medium2.dd03ced5.jpg";